import { types } from "../types/types";

export const setSelectedData = (data) => {
  return {
    type: 'SET_SELECTED_DATA',
    payload: data,
  };
};

export const getSelectedCobranza = () => {
  return {

  }
}

export const updateCobranza = (values) => ({
  type: types.updateCobranza,
  payload: values,
});

export const importUpdateCobranza = (state) => {
  return async (dispatch) => {
    try {
      dispatch(updateCobranza(state))
    } catch (error) {
      console.error(error)
    }
  }
} 